export default function ($translate) {
    return {
        KEYS: {
            FREE_TEXT: 'FREE_TEXT',
            SELECT: 'SELECT'
        },
        LABELS: {
            FREE_TEXT: $translate.instant('metaField.Free text'),
            SELECT: $translate.instant('metaField.Select')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/forms/meta/field/type/index.js